export const vehiclesTableColumns = [
    "id",
    "seller_id",
    "name",
    "year",
    "brand",
    "model",
    "mileage",
    "transmission",
    "fuel_type",
    "engine",
    "capacity",
    "drivetrain",
    "body",
    "vin",
    "title_status",
    "color",
    "interior",
    "images",
    "video",
    "tags",
    "description",
    "created_at",
    "updated_at",
    "condition",
    "owners",
    "interior_color",
    "doors",
    "seats",
    "horsepower",
    "torque",
    "imported",
    "warranty",
    "verified",
    "featured",
    "favorites",
    "active",
    "type",
    "views",
    "published"
];
